module.exports = __webpack_public_path__ + "img/astrick-logo.3c56d8a0.svg";